export default "__VITE_ASSET__cRmGQeyX__"